module.exports = __webpack_public_path__ + "img/horizontal_7_5_8019.cd8c2a9c.png";